import { VideoPopup } from '@/components/VideoPopup'
import React from 'react'
import Navbar from '@/components/Navbar/Navbar'
import useAuth from '@/hooks/stores/useAuth'

export const Intro_video = () => {
  const { userRole } = useAuth();
  
  console.log('Current user role:', userRole);

  return (
    <div className="min-h-screen bg-background">
      {/* Only show Navbar if user is NOT a Legal Advisor */}
      {userRole !== "Legal Advisor" && <Navbar />}
      <VideoPopup />
    </div>
  )
}
